import { Button, Checkbox, Col, Form, Radio, Row, Select, Space, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
import EventEmitter from '../../utils/eventEmitter';
import usePaymentMethodAPI from '../apis/paymentMethodAPI';



const PaymentMethodChanges = () => {
  const { paymentMethod, journals } = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(paymentMethod.name ? paymentMethod.name : '');
  const { create, update } = usePaymentMethodAPI();
  // const [isCash, setIsCash] = useState(paymentMethod.is_cash ? paymentMethod.is_cash : false);

  const onChangeName = e => setName(e.target.value);

  const handleSave = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    // data['is_cash'] = isCash;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    create(data, success);
  };

  const edit = () => { 
    let data = form.getFieldsValue();
    data['name'] = name;
    // data['is_cash'] = isCash;
    data['seo'] = name.toLowerCase().replace(/ /g, '-');
    data['id'] = paymentMethod.id;
    update(paymentMethod.seo, data);
  };

  const handleDiscard = () => { };

  useEffect(() => {
    EventEmitter.subscribe('paymentMethod_response', data => {
      navigate('/pos/payment-methods/'+data);
    });

    return () => {
      EventEmitter.unsubscribe('paymentMethod_response');
    }
  },[])

  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/pos/payment-methods'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Payment Methods</Link> / {params.action}
          </h3>
          <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
            <Button onClick={handleSave} type='text' htmlType='button'
              disabled={ paymentMethod.seo ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
          {/* <Tooltip  title='edit' placement='rightBottom' className='ms-1'>
            <Button onClick={handleDiscard} type='text' htmlType='button'
              // disabled={ formValue.status === 'draft' ? false : true}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<MdEdit />}
            />
          </Tooltip> */}
        </div>
        {paymentMethod.seo && <Button htmlType='button' onClick={edit} icon={<RxUpdate />}>UPDATE</Button>}
      </div>
      <div className='mt-5 p-3 bg-white shadow p-3'>
        <FloatingLabel
          className='text-2xl'
          variant="standard"
          // disabled={formValue.status!== 'discard' ? true : false}
          label="Name"
          value={name} 
          onChange={onChangeName}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={paymentMethod.seo ? paymentMethod : {is_cash: false}}
          // disabled={formValue.status!== 'discard' ? true : false}
          autoComplete="off"
          variant='borderless'
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item labelCol={{md: {span: 10}}} name={'type'} className='font-semibold text-gray-800 mb-4'>
                <Radio.Group>
                  <Space.Compact direction='horizontal'>
                    <Radio value={'cash'}>Cash</Radio>
                    <Radio value={'momo'}>Momo</Radio>
                    <Radio value={'bank'}>Bank</Radio>
                  </Space.Compact>
                </Radio.Group>
              </Form.Item>
              <Form.Item labelCol={{md: {span: 10}}} label='Is Cash' name='is_cash' className='font-semibold text-gray-800 mb-4' valuePropName='checked'>
                <Checkbox />
              </Form.Item>
              
              <Form.Item labelCol={{md: {span: 10}}} label='Journal' name='journal' className='font-semibold text-gray-800 mb-4' >
                <Select options={journals.map(journal => ({value: journal._id, label: journal.name}))}/>
              </Form.Item>
            </Col>
          </Row>
          
        </Form>
      </div>
    </div>
  )
}

export default PaymentMethodChanges;